module.exports = __webpack_public_path__ + "assets/img/marriage-bottom-bg1.3e3ba49e.png";